function escapeCsvCell(value: string) {
	return `"${value.replace(/"/g, '""')}"`;
}

export function buildSavedSearchListCsv(fieldLabel: string, values: string[]) {
	const rows = [fieldLabel, ...values].map((value) => escapeCsvCell(String(value)));
	return `\uFEFF${rows.join("\r\n")}\r\n`;
}

export function buildSavedSearchListFilename(listName: string) {
	const safeName = listName
		.trim()
		.replace(/[\\/:*?"<>|\u0000-\u001f]/g, "-")
		.replace(/\s+/g, " ")
		.slice(0, 120)
		.replace(/[. ]+$/g, "");

	return `${safeName || "saved-list"}.csv`;
}
